import { BaseModel } from "./base-model";

export default class MQuoteListItem {
    id: string;
    no: string;
    identity: string;
    contact: {
        name: string;
        id: string;
    };
    account: {
        name: string;
        id: string;
    };
    type: string;
    orderDate: string;
    hideQuoteTotal: string;
    total: string;
    salesRep: { name: string };
    status: { name: string };
    paymentStatus: string;
    csr: { id: string; };
    date: { booked: string; invoice: string }
    featuredImage: string;
    currency: {
        baseCurrencyCode: string,
        baseCurrencySymbol: string,
        customerCurrencyCode: string,
        customerCurrencySymbol: string,
        exchageRateForCustomer: string
    };


    constructor(options) {
        this.id = options.id || "";
        this.no = options.no || "";
        this.identity = options.identity || "";
        this.featuredImage = options.featuredImage || "";
        if (options.contact) {
            this.contact = {
                name: options.contact.name || "",
                id: options.contact.id || "",
            };
        } else {
            options.contact = {
                name: "",
                id: ""
            }
        }
        if (options.account) {
            this.account = {
                name: options.account.name,
                id: options.account.id
            }
        } else {
            this.account = {
                name: "",
                id: ""
            }
        }
        this.type = options.type || "";
        this.orderDate = options.orderDate || "";
        this.total = options.total || "";
        this.hideQuoteTotal = options.hideQuoteTotal || "0";

        this.salesRep = options.salesRep ? {
            name: options.salesRep.name
        } : {
            name: ""
        };
        this.status = options.status ? {
            name: options.status.name
        } : {
            name: ""
        }
        this.paymentStatus = options.paymentStatus || "";
        this.csr = options.csr ? {
            id: options.csr.id
        } : {
            id: ""
        }
        this.date = {
            booked: options.date ? options.date.booked : "",
            invoice: options.date ? options.date.invoice : ""
        }
        this.currency = {
            baseCurrencyCode: options.currency.baseCurrencyCode,
            baseCurrencySymbol: options.currency.baseCurrencySymbol,
            customerCurrencyCode: options.currency.customerCurrencyCode,
            customerCurrencySymbol: options.currency.customerCurrencySymbol,
            exchageRateForCustomer: options.currency.exchageRateForCustomer
        };
    }

}